export const CONTEXT = 'funds_access_tool' as const;

export function tagMessage(
  from: Entity,
  to: Entity,
  message: AnyValidMessage,
  options: MessageOptions,
): TaggedMessage<Entity> {
  const id = crypto.randomUUID();
  return { ...message, from, to, id, ...options, context: CONTEXT };
}
